import { render } from "./CurrentUser.vue?vue&type=template&id=2acbdf94&scoped=true"
import script from "./CurrentUser.vue?vue&type=script&lang=js"
export * from "./CurrentUser.vue?vue&type=script&lang=js"

import "./CurrentUser.vue?vue&type=style&index=0&id=2acbdf94&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-2acbdf94"

export default script